import { Col, DatePicker, Form, Input, InputNumber, Row, Select } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import gql from 'graphql-tag';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { skuGroupListQuery } from 'src/screens/redeemCode/RedeemCodeTemplateList';
import { Courses } from 'src/types/sku';

const formTailLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};

export const getCourses = gql`
  query getCoursesQuery {
    courses {
      id
      serialId
      name
    }
  }
`;

interface Props {
  form: WrappedFormUtils;
}
interface State {}

export class AddSku extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  skuGroupSelected = () => {
    const { getFieldDecorator } = this.props.form;
    return (
      <Query query={skuGroupListQuery}>
        {({ loading, error, data }) => {
          if (error) return <div>{error.message}</div>;
          if (loading) return <div>loading...</div>;
          if (!data) {
            // @ts-ignore
            // eslint-disable-next-line react/jsx-no-undef
            return <Empty />;
          }
          const skuGroups = data.skuGroups;
          return (
            <Form.Item label="skuGoup" {...formTailLayout}>
              {getFieldDecorator('skuGroupIds', {
                rules: [
                  {
                    required: true,
                    message: '请选择skuGroup',
                  },
                ],
              })(
                <Select mode="multiple" style={{ width: '100%' }} placeholder="请选择skuGroup">
                  {skuGroups.map((skuGroup: { id: number; name: string }) => {
                    return (
                      <Select.Option value={skuGroup.id} key={skuGroup.id}>
                        {skuGroup.name}
                      </Select.Option>
                    );
                  })}
                </Select>,
              )}
            </Form.Item>
          );
        }}
      </Query>
    );
  };

  courseSelected = () => {
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <Query<{ courses: Courses[] }> query={getCourses}>
          {({ error, data }) => {
            if (error) return <div>{error.message}</div>;
            const courses = (data && data.courses) || [];
            return (
              <Form.Item label="课程名称" {...formTailLayout}>
                {getFieldDecorator('courseId', {
                  rules: [
                    {
                      required: true,
                      message: '请选择课程',
                    },
                  ],
                })(
                  <Select placeholder="请选择课程" style={{ width: 218 }}>
                    {courses.map(option => {
                      return (
                        <Select.Option key={option.id}>
                          {option.serialId}-{option.name}
                        </Select.Option>
                      );
                    })}
                  </Select>,
                )}
              </Form.Item>
            );
          }}
        </Query>
      </div>
    );
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <Form>
          <Row>
            <Col span={14}>
              {this.courseSelected()}
              <Form.Item label="sku名称" {...formTailLayout}>
                {getFieldDecorator('name', {
                  rules: [
                    {
                      required: true,
                      message: '请填写sku名称',
                    },
                  ],
                })(<Input placeholder="sku名称" />)}
              </Form.Item>
              <Form.Item label="价格" {...formTailLayout}>
                {getFieldDecorator('price', {
                  rules: [
                    {
                      required: true,
                      message: '请输入价格',
                    },
                  ],
                })(<InputNumber min={0} />)}
              </Form.Item>
              <Form.Item label="课程有效期" {...formTailLayout}>
                {getFieldDecorator('startEndRange', {
                  rules: [
                    {
                      required: true,
                      message: '请添加课程有效期',
                    },
                  ],
                })(<DatePicker.RangePicker />)}
              </Form.Item>
              <Form.Item label="售卖时间" {...formTailLayout}>
                {getFieldDecorator('availableDateRange', {
                  rules: [
                    {
                      required: true,
                      message: '请添加售卖时间',
                    },
                  ],
                })(<DatePicker.RangePicker />)}
              </Form.Item>
              <Form.Item label="结课时间" {...formTailLayout}>
                {getFieldDecorator('completeCourseAt', {
                  rules: [
                    {
                      required: true,
                      message: '请添加结课时间',
                    },
                  ],
                })(<DatePicker />)}
              </Form.Item>
              <Form.Item label="总库存" {...formTailLayout}>
                {getFieldDecorator('totalStock', {
                  rules: [
                    {
                      required: true,
                      message: '请填写总库存',
                    },
                  ],
                })(<InputNumber min={0} />)}
              </Form.Item>
              <Form.Item label="测评截止时间" {...formTailLayout}>
                {getFieldDecorator('quizEndAt')(<DatePicker />)}
              </Form.Item>
              {this.skuGroupSelected()}
              <Form.Item label="原价" {...formTailLayout}>
                {getFieldDecorator('originalPrice', {
                  rules: [
                    {
                      required: false,
                      message: '请填写原价',
                    },
                  ],
                })(<InputNumber min={0} />)}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/stock/AddSku.tsx